import type { FC } from 'react';
import React from 'react';
import type { Brands } from '@edreamsodigeo/frontend-core';
import { useBrand } from '@edreamsodigeo/frontend-core';
import { Image } from '@edreamsodigeo/prisma-design-system';

import useBrandLogoUrl from '@/clientState/hooks/useBrandLogo';
import type { BrandLogoProps } from '@/components/FlightSummary/HotelVoucher/BrandLogo/types';

const ALT_TEXT: Partial<Record<Brands, string> & { fallback: string }> = {
  ED: 'eDreams logo',
  OP: 'Opodo logo',
  GO: 'GoVoyages logo',
  fallback: 'Brand logo',
};

const BrandLogo: FC<BrandLogoProps> = ({
  width,
  height,
  theme = 'default',
  type = 'short',
}) => {
  const brand = useBrand();
  const logoUrl = useBrandLogoUrl({ brand, theme, type });

  return (
    <Image
      src={logoUrl}
      alt={ALT_TEXT[brand] || ALT_TEXT.fallback || ''}
      size="auto"
      sx={{ width, height }}
    />
  );
};

export default BrandLogo;
